import Image from "next/image";
import Link from "next/link";
import { PostData } from "@/type/commonTypes";
import { formatViews } from "@/utils/commonFunctions";
import Icon from "@/components/icons/Icons";
import { BLOG_ROOT } from "@/utils/gloableVariables";

interface BlogCardProps {
  post: PostData;
  className?: string;
  badge?: boolean;
}

export function BlogCard({ post, className }: BlogCardProps) {
  const readTime = post.reading_time;

  return (
    <div
      className={`overflow-hidden w-full max-w-300 xs:max-w-89 rounded-6xl mt-0 shrink-0 bg-[#ffffff33] ${className}`}
    >
      <Link href={`${BLOG_ROOT}${post.permalinks}`}>
        <div className="relative h-52 w-full overflow-hidden">
          <Image
            src={`https://admin.mysiponline.com/app/webroot/blog_uploadimages/${post.img}`}
            alt={post.img_alt || post.txttitle}
            fill
            className="object-cover object-left duration-400 transition-transform hover:scale-[1.04]"
          />
        </div>

        <div className="p-4">
          <p
            className="text-base font-medium text-white hover:text-[#ffffffc0] line-clamp-2 transition-all duration-350"
            title={post.txttitle}
          >
            {post.txttitle}
          </p>

          <ul className="flex items-center gap-2 text-2xs text-medium text-[#FFFFFF80] mt-3">
            <li className="flex items-center gap-1 after:content-['•'] after:inline-block after:text-[#6E6E73]">
              <time dateTime={new Date(post.publish_date).toISOString()}>
                {new Date(post.publish_date).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </time>
            </li>
            <li className="flex items-center gap-1">
              <span>{readTime}</span>
            </li>

            <li className="flex items-center gap-1 ml-auto">
              <i className="h-4 w-4">
                <Icon.viewEyeIcon />
              </i>
              <span>{formatViews(post.view)}</span>
            </li>
          </ul>
        </div>
      </Link>
    </div>
  );
}
